import React from 'react';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import _ from 'lodash';

import * as servingMenuItemsActions from 'PointOfSale/modules/servingOptions/state/actions';
import * as queueActions from 'PointOfSale/modules/queue/state/actions';
import AddSessionModalComponent from 'PointOfSale/modules/servingOptions/component/AddSessionModal';
import {
  AUTO_SERVE_OPTIONS,
  SessionTypes,
  POS_ROUTES,
  QueueStatusEnum,
} from 'PointOfSale/modules/common/constants';
import * as POSSelectors from 'PointOfSale/selectors';

import 'PointOfSale/styles/components/modal.less';
import 'PointOfSale/styles/components/addSessionModal.less';

class AddSessionModal extends React.Component {
  state = {
    currentSelectedSession: '',
    selectedPageIndex: 1,
  };

  onClose = () => {
    this.props.showHideAddSessionModal(false);
    this.setState({ currentSelectedSession: '', selectedPageIndex: 1 });
  };
  setCurrentSelectedSession = session => {
    const currentSession = {
      type: session,
      timeInterval: 5,
      autoServe: false,
      quickServeItem: false,
      quickServeSelectedItem: '',
    };

    this.props.servingMenuItemsActions.setCurrentSession(currentSession);
    this.setState({ currentSelectedSession: session });
  };
  handleBack = index => {
    this.setState({ selectedPageIndex: index });
  };
  handleStartServing = () => {
    const {
      servingMenuItemsActions,
      history,
      currentSession,
      selectedCepType,
    } = this.props;
    const { currentSelectedSession } = this.state;

    const isMealCounter =
      _.get(selectedCepType, 'Id') === AUTO_SERVE_OPTIONS.MealCounter;

    const currentSessionObj = Object.assign(
      { type: currentSelectedSession },
      currentSession
    );

    if (currentSelectedSession === SessionTypes.Queue) {
      currentSessionObj.queueType = isMealCounter
        ? AUTO_SERVE_OPTIONS.MealCounter
        : AUTO_SERVE_OPTIONS.StudentSpecific;
    }

    servingMenuItemsActions.onSessionAdd(currentSessionObj);
    servingMenuItemsActions.clearCurrentSession();

    switch (currentSelectedSession) {
      case SessionTypes.Queue:
        if (currentSession.autoServe) {
          if (isMealCounter) {
            history.replace(POS_ROUTES.MEAL_COUNTER);
          } else {
            history.replace(POS_ROUTES.QUEUE);
          }
        } else {
          history.replace(POS_ROUTES.QUEUE_NEW);
        }
        break;
      case SessionTypes.Teacher:
        history.replace(POS_ROUTES.TEACHER);
        break;
      case SessionTypes.Group:
        history.replace(POS_ROUTES.GROUP);
        break;
      default:
        break;
    }
    this.onClose();
    if (currentSelectedSession === SessionTypes.Queue) {
      this.props.queueActions.shuffleQueue(0);
      if (currentSession && currentSession.autoServe) {
        this.props.queueActions.changeQueueStatus(QueueStatusEnum.PAUSED);
      }
    }
  };

  render() {
    const { open, sessions, activeSession, currentSession } = this.props;
    return (
      <AddSessionModalComponent
        open={open}
        sessions={sessions}
        activeSession={activeSession}
        currentSession={currentSession}
        currentSelectedSession={this.state.currentSelectedSession}
        selectedPageIndex={this.state.selectedPageIndex}
        goToStartingPage={this.handleBack.bind(this, 1)}
        handleBack={this.handleBack}
        handleStartServing={this.handleStartServing}
        queueButtonClick={this.setCurrentSelectedSession.bind(this, 'Queue')}
        groupButtonClick={this.setCurrentSelectedSession.bind(this, 'Group')}
        teacherButtonClick={this.setCurrentSelectedSession.bind(
          this,
          'Teacher'
        )}
        onClose={this.onClose}
      />
    );
  }
}

const mapStateToProps = state => ({
  currentSession: POSSelectors.getCurrentSession(state),
  selectedCepType: POSSelectors.getSelectedCepType(state),
});
const mapDispatchToProps = dispatch => ({
  servingMenuItemsActions: bindActionCreators(
    servingMenuItemsActions,
    dispatch
  ),
  queueActions: bindActionCreators(queueActions, dispatch),
});
export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(AddSessionModal)
);



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/servingOptions/container/AddSessionModal.js